import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  employees: [],
  contracts: [],
  employeeContractInfo: [],
  employee_id: "",
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  employeeContract: []
};

// getters
export const getters = {
  employees: state => state.employees,
  contracts: state => state.contracts,
  employee_id: state => state.employee_id,
  employeeContractInfo: state => state.employeeContractInfo,
  employeeContract: state => state.employeeContract,
  pagination: state => state.pagination
};

// mutations
export const mutations = {
  [types.CONTRACT_EMPLOYEE.FETCH_CONTRACT_EMPLOYEE_REQUEST](
    state,
    employeeContract
  ) {
    state.employeeContract = employeeContract;
    state.pagination.from = employeeContract.from;
    state.pagination.to = employeeContract.to;
    state.pagination.totalPage = employeeContract.last_page;
    state.pagination.path = employeeContract.path;
    state.pagination.currentPage = employeeContract.current_page;
    state.pagination.totalRecord = employeeContract.total;
    state.pagination.perPage = employeeContract.per_page;
  },
  [types.CONTRACT_EMPLOYEE.EMPLOYEES](state, data) {
    state.employees = data;
  },
  [types.CONTRACT_EMPLOYEE.CONTRACTS](state, data) {
    state.contracts = data;
  },
  [types.CONTRACT_EMPLOYEE.GET_INFO_EMPLOYEE_CONTRACT](state, data) {
    state.employeeContractInfo = data.employeeContracts;
    state.employee_id = data.employee_id;
  }
};

// actions
export const actions = {
  async fetchContractEmployee({ commit }, payload) {
    const response = await axios.get(api.LIST_CONTRACT_EMPLOYEE, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_id: payload.employee_id,
        contract_type: payload.contract_type
      }
    });
    commit(
      types.CONTRACT_EMPLOYEE.FETCH_CONTRACT_EMPLOYEE_REQUEST,
      response.data
    );
  },

  async getCommonsData({ commit }) {
    const response = await axios.get(api.GET_COMMON_CONTRACT_EMPLOYEE);
    commit(types.CONTRACT_EMPLOYEE.EMPLOYEES, response.data.employees);
    commit(types.CONTRACT_EMPLOYEE.CONTRACTS, response.data.contracts);
  },

  // eslint-disable-next-line
  async createContractEmployee({ commit }, params) {
    await axios.post(api.CREATE_CONTRACT_EMPLOYEE, params);
  },

  async getInfoEmployeeContract({ commit }, params) {
    let url = `${api.EDIT_CONTRACT_EMPLOYEE}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(types.CONTRACT_EMPLOYEE.GET_INFO_EMPLOYEE_CONTRACT, response.data);
    }
  },

  // eslint-disable-next-line
  async updateContractEmployee({ commit }, params) {
    let url = `${api.UPDATE_CONTRACT_EMPLOYEE}/${params.employee_id}`;
    await axios.post(url, params);
  }
};
